import Cart from '../../../Cart'
import Compair from '../../../Helpers/icons/Compair'
import ThinBag from '../../../Helpers/icons/ThinBag'
import ThinLove from '../../../Helpers/icons/ThinLove'
import ThinPeople from '../../../Helpers/icons/ThinPeople'
import SearchBox from '../../../Helpers/SearchBox'
import { Link } from 'react-router-dom'

export default function Middlebar({ className, type }) {
    return (
        <div className={`w-full h-[86px] bg-white ${className}`}>
            <div className="container-x mx-auto h-full">
                <div className="relative h-full">
                    <div className="flex justify-between items-center h-full">
                        <div>
                            {type === 3 ? (
                                <a href="/">
                                    <img
                                        width="152"
                                        height="36"
                                        src={`${process.env.PUBLIC_URL}/assets/images/logo-3.svg`}
                                        alt="logo"
                                    />
                                </a>
                            ) : type === 4 ? (
                                <a href="/">
                                    <img
                                        width="152"
                                        height="36"
                                        src={`${process.env.PUBLIC_URL}/assets/images/logo-4.svg`}
                                        alt="logo"
                                    />
                                </a>
                            ) : (
                                <a href="/">
                                    <img
                                        width="152"
                                        height="36"
                                        src={`${process.env.PUBLIC_URL}/assets/images/BuildLinkCompleteLogo.png`}
                                        alt="logo"
                                    />
                                </a>
                            )}
                        </div>
                        <div className="w-[517px] h-[44px]">
                            <SearchBox type={type} className="search-com" />
                        </div>
                        <div className="flex space-x-6 items-center">
                            <div className="compaire relative">
                                <a href="/products-compaire">
                                    <span>
                                        <Compair />
                                    </span>
                                </a>
                                <span
                                    className={`w-[18px] h-[18px] rounded-full  absolute -top-2.5 -right-2.5 flex justify-center items-center text-[9px] ${
                                        type === 3
                                            ? 'bg-qh3-blue text-white'
                                            : 'bg-qyellow'
                                    }`}
                                >
                                    2
                                </span>
                            </div>
                            <div className="favorite relative">
                                <a href="/wishlist">
                                    <span>
                                        <ThinLove />
                                    </span>
                                </a>
                                <span
                                    className={`w-[18px] h-[18px] rounded-full  absolute -top-2.5 -right-2.5 flex justify-center items-center text-[9px] ${
                                        type === 3
                                            ? 'bg-qh3-blue text-white'
                                            : 'bg-qyellow'
                                    }`}
                                >
                                    12
                                </span>
                            </div>
                            <div className="cart-wrapper group relative py-4">
                                <div className="cart relative cursor-pointer">
                                    <a href="/cart">
                                        <span>
                                            <ThinBag />
                                        </span>
                                    </a>
                                    <span
                                        className={`w-[18px] h-[18px] rounded-full  absolute -top-2.5 -right-2.5 flex justify-center items-center text-[9px] ${'bg-qh3-blue text-white'}`}
                                    >
                                        1
                                    </span>
                                </div>
                                {/* <div className="fixed left-0 top-0 w-full h-full z-40"></div> */}
                                {/* hidden group-hover:block" */}
                                <Cart
                                    type={type}
                                    className="absolute -right-[45px] top-11 z-50 hidden group-hover:block"
                                />
                            </div>
                            <div>
                                <Link to="/profile">
                                    <span>
                                        <ThinPeople />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
